<div class="container1">
    <div class="section">
        <div class="content">
            <h2>Section 1</h2>
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Veniam repudiandae dolores eaque tempore quod illo esse autem in ad maiores excepturi obcaecati exercitationem dolore, asperiores distinctio, temporibus velit ab minima!</p>
        </div>
    </div>
    <div class="section">
        <div class="content">
            <h2>Section 2</h2>
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Veniam repudiandae dolores eaque tempore quod illo esse autem in ad maiores excepturi obcaecati exercitationem dolore, asperiores distinctio, temporibus velit ab minima!</p>
        </div>
    </div>
    <div class="section">
        <div class="content">
            <h2>Section 3</h2>
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Veniam repudiandae dolores eaque tempore quod illo esse autem in ad maiores excepturi obcaecati exercitationem dolore, asperiores distinctio, temporibus velit ab minima!</p>
        </div>
    </div>
    <div class="section">
        <div class="content">
            <h2>Section 4</h2>
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Veniam repudiandae dolores eaque tempore quod illo esse autem in ad maiores excepturi obcaecati exercitationem dolore, asperiores distinctio, temporibus velit ab minima!</p>
        </div>
    </div>
    <div class="section">
        <div class="content">
            <h2>Section 5</h2>
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Veniam repudiandae dolores eaque tempore quod illo esse autem in ad maiores excepturi obcaecati exercitationem dolore, asperiores distinctio, temporibus velit ab minima!</p>
        </div>
    </div>
</div>
